<template>
    <b-modal
        id="internalInfo-modal"
        ref="internalInfo-modal"
        :title="$t('history.modal.header.InternalInfo')"
        @show="reset"
        @hidden="reset"
        @ok="handleOk"
    >
        <form ref="form">
            <b-form-group>
                <b-tabs content-class="mt-3">
                    <b-tab :title="$t('history.modal.tab.Notes')" active>
                        <div
                            v-for="(item, index) in getMessages('internalNote')"
                            v-bind:key="item.key"
                        >
                            <b-alert show variant="success">
                                <p>
                                    {{ item.createdAt.substring(0, 10) }}
                                    {{ item.createdAt.substring(11, 16) }}
                                    {{ item.createdBy }}
                                </p>

                                <p
                                    style="white-space: pre-line"
                                    :name="'internalMessage' + index"
                                >{{ item.message }}</p>
                            </b-alert>
                        </div>
                    </b-tab>
                    <b-tab :title="$t('history.modal.tab.Tracking')">
                        <div
                            v-for="(item, index) in getMessages('tracking')"
                            v-bind:key="item.key"
                        >
                            <b-alert show variant="success">
                                <p>
                                    {{ item.createdAt.substring(0, 10) }}
                                    {{ item.createdAt.substring(11, 16) }}
                                    {{ item.createdBy }}
                                </p>

                                <p
                                    style="white-space: pre-line"
                                    :name="'internalMessage' + index"
                                >{{ item.message }}</p>
                            </b-alert>
                        </div>
                    </b-tab>

                    <b-tab :title="$t('history.modal.tab.Carrier')">
                        <div
                            v-for="(item, index) in getMessages('carrier')"
                            v-bind:key="item.key"
                        >
                            <b-alert show variant="success">
                                <p>
                                    {{ item.createdAt.substring(0, 10) }}
                                    {{ item.createdAt.substring(11, 16) }}
                                    {{ item.createdBy }}
                                </p>

                                <p
                                    style="white-space: pre-line"
                                    :name="'internalMessage' + index"
                                >{{ item.message }}</p>
                            </b-alert>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-form-group>

            <b-form-group :invalid-feedback="invalidFeedback">
                <b-form-input
                    v-model="internalMessage"
                    :state="internalMessageState"
                    required
                    name="internalMessageInput"
                    :placeholder="$t('history.placeholder.Add Comment')"
                ></b-form-input>
            </b-form-group>
        </form>

        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button @click="cancel()">Cancel</b-button>
            <b-button
                @click="ok()"
                name="addInternalMessageModalButton"
                variant="primary"
            >{{ $t('history.modal.button.AddComment') }}</b-button>
        </template>
    </b-modal>
</template>
<script>
  import { CORE_PREFIX, ACTIONS, MUTATIONS, HISTORY_PREFIX } from '@/store/constants';
  import helpers from '@/helper';
  import { readSync } from 'fs';

  export default {
      props: {
          shipment: { type: Object, required: true },
      },

      data() {
          return {
              internalMessage: '',
              invalidFeedback: '',
              messages: [],
              internalMessageState: null,
          };
      },

      methods: {
          getMessages(type) {
              let result = this.messages.filter(
                  (message) => message.type.toLowerCase() == type.toLowerCase()
              );
              return result;
          },
          async showInternalMessagesModal() {
              const response = await this.$store.dispatch(
                  HISTORY_PREFIX + ACTIONS.HISTORY.FETCH_INTERNAL_MESSAGES,
                  this.shipment.id
              );

              this.messages = response.data;

              this.$refs['internalInfo-modal'].show();
          },

          handleOk(bvModalEvt) {
              bvModalEvt.preventDefault();
              this.addInternalInfoNote();
          },

          async addInternalInfoNote() {
              if (!this.isFormValid()) {
                  return;
              }

              let obj = { shipment: this.shipment, message: this.internalMessage };

              this.$store.dispatch(HISTORY_PREFIX + ACTIONS.HISTORY.SET_INTERNAL_MESSAGE, obj);

              this.shipment.hasInternalNotes = true;

              this.internalMessage = '';

              this.$nextTick(() => {
                  this.$bvModal.hide('internalInfo-modal');
              });
          },

          isFormValid() {
              if (!this.$refs.form.checkValidity()) {
                  this.internalMessageState = false;
                  this.invalidFeedback = 'A message is required';
                  return false;
              }

              if (this.internalMessage.length > 300) {
                  this.internalMessageState = false;
                  this.invalidFeedback = 'The message cant be longer than 300 characters.';
                  return false;
              }

              return true;
          },

          reset() {
              this.internalMessage = '';
              this.internalMessageState = null;
          },
      },
  };
</script>

<style></style>
